import { Injectable } from '@angular/core';

import { EcommerceConfigService } from 'idt-ecommerce-api/config/ecommerce-config.service';


@Injectable()
export class EcommerceUrlResolverService {

  constructor(private readonly ecommerceConfigService: EcommerceConfigService) {}

  public get baseEcommerceApiUrl(): string {
    const { apiEcommerceBaseUrl } = this.ecommerceConfigService.getConfig();
    if (apiEcommerceBaseUrl === undefined) {
      throw new Error('EcommerceConfigService: apiEcommerceBaseUrl not set');
    }
    return apiEcommerceBaseUrl;
  }

  public get ecommerceAppId(): string {
    return this.ecommerceConfigService.getConfig().appId.toString();
  }

  public resolveEcommerceAPI(version: number, ...params: string[]): string {
    const baseEcommerceApiUrl = this.getBaseUrlEcommerceApi(version);
    const url = this.getPath(params);
    let absoluteUrl = baseEcommerceApiUrl.concat(url);

    if (version === 3 && !url.includes('appId=')) {
      absoluteUrl = absoluteUrl.concat(`&appId=${this.ecommerceAppId}`);
    }

    return absoluteUrl;
  }

  public resolveStorefrontAPI(version: number, ...params: string[]): string {
    const host = this.baseEcommerceApiUrl.replace(/\/itxrest$/, '');
    const base = `${host}/api/storefront/${version}/`;
    const path = this.getPath(params);
    return base.concat(path);
  }

  private getBaseUrlEcommerceApi(version: number): string {
    return `${this.baseEcommerceApiUrl}/${version}/`;
  }

  private getPath(params: string[]): string {
    if (!params.length) {
      throw new Error('wrong arguments to setUrls');
    }

    let url = params.slice(0, 1)[0];

    params.splice(1).forEach(
      (param: string) => {
        url = url.replace(/%s/, param);
      }
    );

    return url;
  }

}
